import { isPlatformServer } from '@angular/common';
import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Response } from 'express';

@Injectable()
export class SsrResponseService {
  protected _platformId = inject(PLATFORM_ID);
  protected get _isPlatformServer(): boolean {
    return isPlatformServer(this._platformId);
  }

  private _response = inject(RESPONSE, { optional: true });

  get response(): Response | null {
    return this._response;
  }
}
